import * as L from 'leaflet';
import { Subject } from 'rxjs';

import { MapFeature, MapGeometryType } from '../map-feature';
import { MapObject } from '../map-object';

/** Common visibility and Leaflet-container lifecycle for geometry features. */
export abstract class GeometryFeatureBase<TObject extends MapObject>
implements MapFeature<TObject> {
  abstract readonly key: string;
  abstract readonly name: string;
  abstract readonly geometryType: MapGeometryType;

  readonly layer: L.LayerGroup = L.layerGroup();
  readonly changed$ = new Subject<void>();
  enabled = true;
  abstract objects: TObject[];

  readonly icon?: string;
  readonly iconColor?: string;
  readonly page?: string;

  protected notifyChanged(): void {
    this.changed$.next();
  }

  abstract render(): void;

  clear(): void {
    this.layer.clearLayers();
  }
}
